<template>
  <el-row>
    <div class="block">
      <el-timeline>
        <template v-for="(message, index) in enquiryNotes()">
          <el-timeline-item
            v-if="message.body_text.length > 0"
            :key="index"
            :timestamp="formatDate(message.created_at)"
            :reverse="false"
            placement="top"
          >
            <el-card>
              <!-- eslint-disable vue/no-v-html -->
              <h4 v-html="message.body" />
              <el-tag
                v-if="message.incoming === true"
                size="mini"
              >
                Incoming
              </el-tag>
              <el-tag
                v-else
                size="mini"
                type="success"
              >
                Outgoing
              </el-tag>
              <p>
                {{ getDisplayName(message.user_id) }}
              </p>
            </el-card>
          </el-timeline-item>
        </template>
      </el-timeline>
    </div>
  </el-row>
</template>
<script>
import Request, { GET } from '@/plugins/sdk/Request'

export default {
  props: {
    enquiry: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      requesters: {}
    }
  },
  created () {
    this.enquiry.conversations.forEach(message => {
      this.loadRequester(message.user_id)
    })
    this.loadRequester(this.enquiry.requester_id)
  },
  methods: {
    formatDate (value) {
      return this.$moment(value).format('DD-MM-YYYY HH:mm:ss')
    },
    async loadRequester (id) {
      const request = await (Object.assign(new Request(), {
        method: GET,
        _pathname: 'freshdesk/requester/' + id
      })).build()

      const response = await fetch(request)

      this.requesters[id] = (await response.json())
    },
    enquiryNotes () {
      let reversed = this.$_.clone(this.enquiry.conversations).reverse()
      reversed.push({
        created_at: this.enquiry.created_at,
        body_text: this.enquiry.description_text,
        body: this.enquiry.description,
        user_id: this.enquiry.requester_id,
        incoming: true
      })
      return reversed
    },
    getDisplayName (userId) {
      if (this.requesters.hasOwnProperty(userId)) {
        if (this.requesters[userId].hasOwnProperty('org_agent_id')) {
          return this.requesters[userId].contact.name
        }
        return this.requesters[userId].name
      }
      return '-'
    }
  }
}
</script>
